import { MutationHookOptions, useMutation } from '@apollo/client';
import updateDepotMutation from './updateDepotMutation.graphql';

export const useUpdateDepotMutation = (
  options?: MutationHookOptions<any, any>,
) => {
  return useMutation<any, any>(updateDepotMutation, {
    awaitRefetchQueries: true,
    refetchQueries: [
      'ManagedDepotsFromPlatformAccount',
      'ManagedDepots',
      'ManagementDepot',
    ],
    ...options,
  });
};
